export const DEFAULT_USE_STATIC_TRANSFORMS = true;

export const DEFAULT_SHOW_ROTATION_CONTROLS = true;

export const DEFAULT_TERMINAL_AUTO_SCROLL = true;
